import React from 'react';
import toastNotification, { dismissToast } from './ToastNotification';

const showToastNotification = (
  type: 'success' | 'error' | 'warning' | 'info',
  description: string,
  closeToast?: React.MutableRefObject<(() => void) | null>,
) => {
  // Dismiss any existing toast before showing a new one
  dismissToast();

  if (closeToast) {
    closeToast.current = dismissToast;
  }

  toastNotification({ type, description });
};

export default showToastNotification;
